import React from 'react';

const InputToggle = ({ label, register }) => {
  return (
    <label className="input-toggle">
      <input type="checkbox" className="hidden" {...register}/>
      <span className="input-toggle__check"></span>
      <span className="text-black-900">{ label }</span>
    </label>
  )
}

export default InputToggle;